import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Group, GroupHeader, GroupSettingsProfiles } from 'pages/settings/sections/groups/types';
import {
  AntivirusProfile,
  Profile,
  GlobalSettings,
  initAntivirusScheduleProfiles,
  initGroupsWithSamePlatform,
  initGlobalSettings,
  initGroupProfiles,
  initFileMonitorProfiles,
  initStorageDevicesProfiles,
  initWindowsEventsProfiles
} from './groupSettingsActions';

export interface GroupSettingsSlice {
  antivirusScheduleProfiles: AntivirusProfile[] | undefined;
  groupProfiles?: GroupSettingsProfiles;
  fileMonitoringProfiles: Profile[] | undefined;
  storageDevicesProfiles: Profile[] | undefined;
  windowsEventsProfiles: Profile[] | undefined;
  groupsWithSamePlatform: GroupHeader[] | undefined;
  globalSettings: GlobalSettings | undefined;
  currentGroup: Group | undefined;
  loading: boolean;
}

const initialState: GroupSettingsSlice = {
  antivirusScheduleProfiles: undefined,
  groupProfiles: undefined,
  fileMonitoringProfiles: undefined,
  storageDevicesProfiles: undefined,
  windowsEventsProfiles: undefined,
  groupsWithSamePlatform: undefined,
  globalSettings: undefined,
  currentGroup: undefined,
  loading: false
};

export const groupSettingsSlice = createSlice({
  name: 'groupSettings',
  initialState,
  reducers: {
    resetGroupSettingsSlice: () => initialState,
    setCurrentGroupWithSettings: (state, action: PayloadAction<Group>) => {
      state.currentGroup = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(initAntivirusScheduleProfiles.fulfilled, (state, { payload }) => {
      state.antivirusScheduleProfiles = payload;
    });
    builder.addCase(initGroupProfiles.fulfilled, (state, { payload }) => {
      state.groupProfiles = payload;
    });
    builder.addCase(initFileMonitorProfiles.fulfilled, (state, { payload }) => {
      state.fileMonitoringProfiles = payload;
    });
    builder.addCase(initStorageDevicesProfiles.fulfilled, (state, { payload }) => {
      state.storageDevicesProfiles = payload;
    });
    builder.addCase(initWindowsEventsProfiles.fulfilled, (state, { payload }) => {
      state.windowsEventsProfiles = payload;
    });
    builder.addCase(initGroupsWithSamePlatform.pending, state => {
      state.loading = true;
    });
    builder.addCase(initGroupsWithSamePlatform.fulfilled, (state, { payload }) => {
      state.groupsWithSamePlatform = payload;
      state.loading = false;
    });
    builder.addCase(initGroupsWithSamePlatform.rejected, state => {
      state.loading = false;
    });
    builder.addCase(initGlobalSettings.fulfilled, (state, { payload }) => {
      state.globalSettings = payload;
    });
  }
});

export const { resetGroupSettingsSlice, setCurrentGroupWithSettings } = groupSettingsSlice.actions;

export default groupSettingsSlice.reducer;
